// import {
//   useQuery,
//   useMutation,
//   useQueryClient,
// } from '@tanstack/react-query';

// import { bannerServices } from '../services/banner.service';


// // CREATE + UPLOAD
// export const useUploadBannerImage = () => {

//   const queryClient = useQueryClient();

//   return useMutation({

//     mutationFn:
//       bannerServices.uploadBannerImage,

//     onSuccess: () => {

//       queryClient.invalidateQueries({
//         queryKey: ['banners'],
//       });

//     },
//   });
// };


// // GET
// export const useBanners = (params) => {

//   return useQuery({

//     queryKey: ['banners', params],

//     queryFn: () =>
//       bannerServices.getBanners(params),

//     keepPreviousData: true,
//   });
// };


// // DELETE
// export const useDeleteBanner = () => {

//   const queryClient = useQueryClient();

//   return useMutation({

//     mutationFn:
//       bannerServices.deleteBanner,

//     onSuccess: () => {

//       queryClient.invalidateQueries({
//         queryKey: ['banners'],
//       });

//     },
//   });
// };

// // UPDATE BANNER
// export const useUpdateBanner = () => {

//   const queryClient = useQueryClient();

//   return useMutation({

//     mutationFn:
//       bannerServices.updateBanner,

//     onSuccess: () => {

//       queryClient.invalidateQueries({
//         queryKey: ['banners'],
//       });

//     },
//   });
// };



import {
  useQuery,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';

import { bannerServices } from '../services/banner.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Upload banner image
 */
export const useUploadBannerImage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      try {
        return await bannerServices.uploadBannerImage(
          data
        );
      } catch (error) {
        throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['banners'],
      });
    },

    retry: 1,
  });
};

/**
 * Get all banners
 */
export const useBanners = (params) => {
  return useQuery({
    queryKey: ['banners', params],

    queryFn: async () => {
      try {
        return await bannerServices.getBanners(
          params
        );
      } catch (error) {
        throw parseApiError(error);
      }
    },

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    placeholderData: (previousData) =>
      previousData,

    retry: 1,
  });
};

/**
 * Delete banner
 */
export const useDeleteBanner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (bannerId) => {
      try {
        return await bannerServices.deleteBanner(
          bannerId
        );
      } catch (error) {
        throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['banners'],
      });
    },

    retry: 1,
  });
};

/**
 * Update banner
 */
export const useUpdateBanner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data) => {
      try {
        return await bannerServices.updateBanner(
          data
        );
      } catch (error) {
        throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['banners'],
      });
    },

    retry: 1,
  });
};